module.exports = __webpack_public_path__ + "media/images/sp/specials/common/present_online_support-6d4cbbba2be4e673b1ffada0cce06d5d.png";